import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DataService } from "../data.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Subject } from "rxjs";
import { ToastrManager } from "ng6-toastr-notifications";

@Component({
  selector: "app-list-policy",
  templateUrl: "./list-policy.component.html",
  styleUrls: ["./list-policy.component.css"]
})
export class ListPolicyComponent {
  public policyData = { Policy: [] };
  public Submitted: boolean = false;
  public groupName;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrManager
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      rowCallback: (row: Node, data: Object, index: number) => {
        const self = this;

        $(".checkAll").unbind("change");
        $(".checkAll").bind("change", () => {
          if ($(".checkAll").is(":checked")) {
            $("input[type='checkbox']").prop("checked", true);
          } else {
            $("input[type='checkbox']").prop("checked", false);
          }
        });

        return row;
      }
    };
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 1.5 seconds */
      this.spinner.hide();
    }, 1500);
    this.getGroupRolePolicy();
  }

  getGroupRolePolicy(): void {
    this.route.params.subscribe(params => {
      console.log(params);
      this.groupName = params;
      this.dataService.getGroupRolePolicy(params).subscribe((Data: any) => {
        console.log(typeof Data);
        var newData;
        if (typeof Data == "string") {
          newData = JSON.parse(Data);
        } else {
          newData = Data;
        }
        console.log(newData);
        if (newData.Status == "Success") {
          newData = JSON.parse(decodeURIComponent(newData.Data.PolicyDocument));
          console.log(newData.Statement);
          for (let i = 0; i < newData.Statement.length; i++) {
            this.policyData.Policy.push({
              bucketName:
                newData.Statement[i].Resource == "*"
                  ? this.groupName.groupName
                  : newData.Statement[i].Resource,
              read:
                newData.Statement[i].Action.indexOf("s3:GetObject") > -1 ||
                newData.Statement[i].Action.indexOf("cognito-idp:List*") > -1||
                newData.Statement[i].Action.indexOf("iam:Get*") > -1
                  ? true
                  : false,
              write:
                newData.Statement[i].Action.indexOf(
                  "cognito-idp:CreateGroup"
                ) >-1 ||
                newData.Statement[i].Action.indexOf("s3:PutObject") >-1 ||
                newData.Statement[i].Action.indexOf("iam:CreateUser") > -1
                  ? true
                  : false,
              full:
                newData.Statement[i].Action.indexOf("cognito-idp:*") >-1 ||
                newData.Statement[i].Action.indexOf("s3:*") >-1 ||
                newData.Statement[i].Action.indexOf("iam:*") > -1
                  ? true
                  : false
            });
          }
        } else if (newData.Status == "Error") {
          // alert(newData.Error.message)
          this.toastr.errorToastr(newData.Error.message, "oops!");
        }

        console.log(this.policyData.Policy);

        this.Submitted = true;
        this.dtTrigger.next();
      });
    });
  }
}
